import moment from "moment";
import React from "react";

const VitalView = ({ label, previousVisits }) => {
  const filteredVisits = previousVisits?.filter((visit) =>
    visit.qp_cm_vitals?.some(
      (vital) => vital?.type?.label?.toLowerCase() === label?.toLowerCase()
    )
  );

  const getVitalToRender = (vitalData, date_created) => {
    let vital = "";
    const count = vitalData?.type?.no_of_fields;
    const seperator = vitalData?.type?.seperator;
    let result = [];

    for (let i = 1; i <= count; i++) {
      vital += `${vitalData[`value${i}`]} ${i === count ? "" : seperator} `;
    }

    result.push(
      <div
        className="flex justify-between items-center"
        key={`${vitalData?.id}-${vitalData?.type?.seperator}`}
      >
        <div>{moment(date_created).format("DD MMMM YYYY hh:mm A")}</div>
        <div>
          <span>{`${vital} ${vitalData?.selected_unit}`}</span>
        </div>
      </div>
    );

    if (vitalData?.type?.label?.toLowerCase() === "bp") {
      const readings =
        vitalData?.reading?.map((ele, idx) => (
          <div
            className="flex justify-between items-center"
            key={`${idx}-${ele?.value1}-${ele?.value2}`}
          >
            <div>{moment(ele?.timeStamp).format("DD MMMM YYYY hh:mm A")}</div>
            <div>
              <span>{`${ele?.value1} / ${ele?.value2} ${ele?.valueUnit}`}</span>
            </div>
          </div>
        )) || [];
      result = [...result, ...readings];
    }

    return result;
  };

  return (
    <div className="w-[297px] px-2 py-3">
      {filteredVisits?.map((visit, i) => {
        const vitalData = visit?.qp_cm_vitals.find(
          (vital) => vital?.type?.label?.toLowerCase() === label?.toLowerCase()
        );

        return (
          <>
            {vitalData &&
              getVitalToRender(vitalData, visit?.date_created)?.map(
                (vtl) => vtl
              )}
          </>
        );
      })}
    </div>
  );
};

export default VitalView;
